import { useState, useEffect } from 'react'
import { createContainer } from 'unstated-next'
import moment from 'moment'
import { NavigationTrackerContainer } from '../../../infrastructure/navigation'
import { StockFiltersContainer } from '../filters/filtersStore'
import { MktSaleType, StockSimulation } from '../stockModels'

function useSimulationBoard() {
    let stockFiltersStore = StockFiltersContainer.useContainer()
    let navigationTracker = NavigationTrackerContainer.useContainer()

    let [simulations, setSimulations] = useState<StockSimulation[]>([])

    useEffect(() => {
        clearSimulation()
    }, [navigationTracker.currentPath, stockFiltersStore.filters.values])

    let addOrUpdateSimulation = (simulation: StockSimulation) => {
        let actualSimulations = [...simulations]
        let simulationIndex = actualSimulations.findIndex(x => x.date == simulation.date && x.movementType == simulation.movementType)
        if (simulationIndex >= 0)
            actualSimulations[simulationIndex] = simulation
        else
            actualSimulations.push(simulation)
        setSimulations(actualSimulations)
    }

    let removeSimulation = (date: string, movementType: string): boolean => {
        let actualSimulations = [...simulations]
        let simulationIndex = actualSimulations.findIndex(x => x.date == date && x.movementType == movementType)
        if (simulationIndex >= 0)
            actualSimulations.splice(simulationIndex, 1)
        else
            return false
        setSimulations(actualSimulations)
        return true
    }

    let clearSimulation = () => {
        setSimulations([])
    }

    let isOutsideMktSalesPeriod = (simulation: StockSimulation, start: string, end: string) =>
        simulation.movementType !== MktSaleType
        || !moment(simulation.date).isBetween(moment(start), moment(end), 'day', '[]')

    let applyMktSalesSimulations = (entries: { date: string, value: number }[], start: string, end: string) => {
        setSimulations(current => [
            ...current.filter(x => isOutsideMktSalesPeriod(x, start, end)),
            ...entries.map(x => ({ date: x.date, value: x.value, movementType: MktSaleType }))
        ])
    }

    let clearMktSalesSimulations = (start: string, end: string) => {
        setSimulations(current => current.filter(x => isOutsideMktSalesPeriod(x, start, end)))
    }

    return { simulations, addOrUpdateSimulation, removeSimulation, clearSimulation, applyMktSalesSimulations, clearMktSalesSimulations }
}

export let SimulationBoardContainer = createContainer(useSimulationBoard)
